import React from "react";
import WhatsAppFAB from "./WhatsAppFAB";

const Footer = () => {
  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-end",
          marginRight:"40px"
        }}
      >
        <WhatsAppFAB/>
      </div>
    </React.Fragment>
  );
};

export default Footer;
